import React from 'react';

import { Button, ButtonProps, Tooltip } from '@mui/material';

type CustomButtonProps = {
  label: string;
  handleClick: () => void;
  buttonColor?: string;
  disabled?: boolean;
  tooltipText?: string;
} & ButtonProps;

const ButtonWithText: React.FC<CustomButtonProps> = ({
  label,
  handleClick,
  buttonColor = '#282583',
  disabled,
  tooltipText,
  ...rest
}) => {
  const button = (
    <Button
      variant='outlined'
      onClick={handleClick}
      size='large'
      disabled={disabled}
      sx={{
        backgroundColor: disabled ? '#f5f5f5' : buttonColor,
        color: disabled ? '#999999' : '#fff',
        borderColor: disabled ? '#e0e0e0' : buttonColor,
        '&:hover': disabled
          ? {}
          : {
              backgroundColor: '#fff',
              color: buttonColor,
              borderColor: buttonColor,
            },
        opacity: disabled ? 0.7 : 1,
        transition: 'all 0.3s ease',
        height: '100%',
        ...rest.sx,
      }}
      {...rest}
    >
      {label}
    </Button>
  );

  if (disabled && tooltipText) {
    return (
      <Tooltip title={tooltipText} placement='top'>
        <span style={{ height: '100%' }}>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default ButtonWithText;
